
import React from 'react';
import { useDispatch, useSelector  } from 'react-redux';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import { IfComp } from '../../core';
import { getMapLayerById } from '../../project';

import { getActions } from '../sagas';
import { getInfo } from '../reducers'
import { INFO_TYPE_HOME } from '../reducers/infoPanelType';
import { getObjectList } from '../reducers/info'

import useDataModelItem from '../hooks/useDataModelItem';

function processTemplateValues(template, values) {
    for (let name in values) {
        template = template.replace(new RegExp(`@${name}@`, 'g'), values[name]);
    }
    return template;
}

const ObjectItem = ({dataActions, dataModelItem, num, objectItem}) => {

    const handleClick = () => {
        dataActions.setObject(objectItem);
    }

    const getTitle = () => {
        let title = `${dataModelItem.title} ${num}`;
        if (dataModelItem.titleForList) {
            title = dataModelItem.titleForList;
        }
        title = processTemplateValues(title, objectItem.attributes);
        return title;
    }

    return (dataModelItem)
        ? <Link onClick={handleClick}>{getTitle()}</Link>
        : null;
}

const ObjectList = ({dataActions, dataModelItem, objectList}) => {
    return (
        <Stack>
            {objectList.map((item, index) => {
                return (
                    <ObjectItem
                        key={index}
                        num={index + 1}
                        dataActions={dataActions}
                        dataModelItem={dataModelItem}
                        objectItem={item}
                    />
                );
            })}
        </Stack>
    );
}

const ObjectListType = ({dataActions, objectList, type}) => {

    const classNames = mergeStyleSets({
        ObjectListType: {
        },
        header: {
            paddingTop: 2,
            paddingBottom: 2,
        },
        objectList: {
            paddingLeft: 8
        }
    });

    const project = useSelector(state => state.project);
    const mapLayer = getMapLayerById(project, type);
    const dataModelItem = useDataModelItem(mapLayer);

    return (
        <IfComp cond={dataModelItem}>
            <Stack classNames={classNames.ObjectListType}>
                <Stack horizontal className={classNames.header} tokens={{childrenGap: 4}}>
                    <Stack.Item>{dataModelItem ? dataModelItem.title : ''}</Stack.Item>
                    <Stack.Item>({objectList.length})</Stack.Item>
                </Stack>
                <Stack.Item className={classNames.objectList}>
                    <ObjectList
                        dataActions={dataActions}
                        dataModelItem={dataModelItem}
                        objectList={objectList}
                    />
                </Stack.Item>
            </Stack>
        </IfComp>
    );
}

const ObjectListTypes = ({dataActions, objectList}) => {

    const sortObjectsByType = (objectList) => {
        let objectsTypes = {};
        objectList.forEach(item => {
            let objectsType = objectsTypes[item.layerId] || [];
            objectsType.push(item);
            objectsTypes[item.layerId] = objectsType;
        });
        return objectsTypes;
    }

    const objectListTypes = sortObjectsByType(objectList);
    const types = [];
    for (let type in objectListTypes) {
        types.push(type);
    }

    return (
        <Stack tokens={{childrenGap: 4}}>
            {types.map(item => {
                const objectListType = objectListTypes[item];
                return (
                    <ObjectListType
                        key={item}
                        dataActions={dataActions}
                        type={item}
                        objectList={objectListType}
                    />
                );
            })}
        </Stack>
    );
}

const ObjectListPanel = () => {

    const classNames = mergeStyleSets({
        ObjectListPanel: {
        },
        content: {
            overflowY: 'auto',
            height: 0
        }
    });

    const dispatch = useDispatch();
    const dataActions = getActions(dispatch);

    const objectList = useSelector(state => getObjectList(getInfo(state.data)));

    const handleCloseClick = () => {
        dataActions.setType(INFO_TYPE_HOME);
    }

    return (
        <Stack verticalFill className={classNames.ObjectListPanel} tokens={{childrenGap: 8}}>
            <IfComp cond={!!objectList}>
                <Stack.Item grow className={classNames.content}>
                    <ObjectListTypes
                        dataActions={dataActions}
                        objectList={objectList}
                    />
                    <Stack horizontal horizontalAlign="end" tokens={{childrenGap: 8}}>
                        <Link onClick={handleCloseClick} title="Zpět na úvodní stránku Datového panelu">Zpět</Link>
                    </Stack>
                </Stack.Item>
            </IfComp>
        </Stack>
    );
}

export default ObjectListPanel;
